import { render, staticRenderFns } from "./GroupbuyingsDetailInfo.vue?vue&type=template&id=3d84f355&"
import script from "./GroupbuyingsDetailInfo.vue?vue&type=script&lang=js&"
export * from "./GroupbuyingsDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports